import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/index/banner1.png'
import _imports_1 from '../assets/index/banner2.png'


const _hoisted_1 = { id: "home-view" }
const _hoisted_2 = { style: {"position":"relative"} }
const _hoisted_3 = { class: "banner-font-container" }
const _hoisted_4 = { style: {"display":"flex"} }
const _hoisted_5 = { style: {"height":"655px","padding-top":"147px","background-color":"#fff"} }
const _hoisted_6 = { style: {"height":"700px","background-color":"#f3f3f3","margin-top":"120px"} }
const _hoisted_7 = { style: {"display":"flex","margin-top":"90px","justify-content":"center"} }
const _hoisted_8 = { style: {"padding-top":"70px","padding-bottom":"200px","background-color":"#fff","display":"flex","justify-content":"center","align-items":"center","flex-direction":"column"} }
const _hoisted_9 = { style: {"margin-top":"50px","width":"1100px","justify-content":"center","align-items":"center","display":"grid","grid-template-columns":"repeat(5, 1fr)","gap":"80px"} }
const _hoisted_10 = ["src"]

import FontOverlay from "@/components/FontOverlay.vue";
import FunctionBox from "@/components/FunctionBox.vue";
import { ref } from "vue";
import asusImg from "@/assets/customers/asus.png";
import dhl from "@/assets/customers/dhl.png";
import c1Img from "@/assets/customers/c1.png";
import expe from "@/assets/customers/expeditors.png";
import chro from "@/assets/customers/chrobinson.png";
import cmcl from "@/assets/customers/chinaMerchantsLogistics.png";
import ceva from "@/assets/customers/ceva.png";
import philips from "@/assets/customers/philips.png";
import cat from "@/assets/customers/cat.png";
import hisense from "@/assets/customers/hisense.png";
import ikea from "@/assets/customers/ikea.png";
import foxconn from "@/assets/customers/foxconn.png";
import walmart from "@/assets/customers/walmart.png";
import router from "@/router";


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const images = ref([
  dhl,
  expe,
  chro,
  cmcl,
  ceva,
  asusImg,
  philips,
  cat,
  c1Img,
  hisense,
  ikea,
  foxconn,
  walmart,
]);
document.addEventListener("scroll", function () {
  const yunshuInDiv = document.querySelector(".wenText");
  if (yunshuInDiv) {
    const yunshu1Position = yunshuInDiv.getBoundingClientRect().top;
    const yunshu2Position = window.innerHeight;

    if (yunshu1Position < yunshu2Position) {
      yunshuInDiv.classList.add("hide");
    }
  }
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_carousel, {
        height: "890px",
        interval: 5000,
        arrow: "always"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_carousel_item, null, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_3, [
                  _cache[4] || (_cache[4] = _createElementVNode("p", { style: {"font-size":"72px","font-weight":"bold"} }, "礼邦物流", -1)),
                  _cache[5] || (_cache[5] = _createElementVNode("p", null, "专业的管理人员和运输队伍;", -1)),
                  _cache[6] || (_cache[6] = _createElementVNode("p", null, "严格、科学的管理手段,现代化的办公设施;", -1)),
                  _cache[7] || (_cache[7] = _createElementVNode("p", null, "通过物流配送服务,将客户的货品运达全球任何地方", -1)),
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_el_button, {
                      style: {
                    backgroundColor: 'transparent',
                    color: 'rgb(255 255 255)',
                  },
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/about')))
                    }, {
                      default: _withCtx(() => _cache[2] || (_cache[2] = [
                        _createTextVNode("关于我们")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      style: _normalizeStyle([{
                    backgroundColor: 'transparent',
                    color: 'rgb(255 255 255)',
                  }, {"margin-left":"15px"}]),
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).push('/services')))
                    }, {
                      default: _withCtx(() => _cache[3] || (_cache[3] = [
                        _createTextVNode("服务简介")
                      ])),
                      _: 1
                    })
                  ])
                ]),
                _cache[8] || (_cache[8] = _createElementVNode("img", {
                  style: {"height":"100%"},
                  src: _imports_0,
                  alt: "logo"
                }, null, -1))
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_carousel_item, null, {
            default: _withCtx(() => _cache[9] || (_cache[9] = [
              _createElementVNode("div", null, [
                _createElementVNode("img", {
                  style: {"height":"100%"},
                  src: _imports_1,
                  alt: "logo"
                })
              ], -1)
            ])),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(FontOverlay, {
        "front-end-font": "关于礼邦",
        "backend-font": "ABOUT  REPPON",
        "class-name": "ABOUT_REPPON"
      }),
      _cache[10] || (_cache[10] = _createElementVNode("div", { class: "about-reppon-text wenText" }, [
        _createElementVNode("p", null, " 上海礼邦物流有限公司(REPPON LOGISTICS)成立于2002年，专业从事进出口集装箱运输、仓储、进口拆箱以及出口拼箱等多种形式的业务服务。 "),
        _createElementVNode("p", null, " "),
        _createElementVNode("p", null, " 公司拥有一批从事物流方面的专业人才，员工均接受过专业培训，本司坚持以市场为导向、以客户为中心、以“感动服务”为行动的经营方针; "),
        _createElementVNode("p", null, " "),
        _createElementVNode("p", null, " 采用现代物流先进的管理模式，可提供全方位一体化的物流服务，公司建立了一整套完整的物流服务管理系统，从客户接待、业务洽谈、货物运输、客户意见反馈、电话回访等、都有专人负责，专人管理。 ")
      ], -1))
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(FontOverlay, {
        "front-end-font": "服务介绍",
        "backend-font": "SERVICE  INTRODUCTION",
        "class-name": "SERVICE_INTRODUCTION"
      }),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(FunctionBox, {
          icon: "reppon-icon icon-icon_519",
          text: "订舱"
        }),
        _createVNode(FunctionBox, {
          icon: "reppon-icon icon-shiyongwendang",
          text: "报关"
        }),
        _createVNode(FunctionBox, {
          icon: "reppon-icon icon-huowudui",
          text: "运输"
        }),
        _createVNode(FunctionBox, {
          icon: "reppon-icon icon-cangku",
          text: "仓储"
        }),
        _createVNode(FunctionBox, {
          icon: "reppon-icon icon-wuliuqiache",
          text: "堆场"
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(FontOverlay, {
        "backend-font": "OUR CUSTOMERS",
        "class-name": "OUR_CUSTOMERS",
        "front-end-font": "我们的客户"
      }),
      _createElementVNode("div", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(images.value, (image, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "image-container"
          }, [
            _createElementVNode("img", {
              src: image,
              alt: "",
              style: {"width":"100%","height":"80px","object-fit":"contain"}
            }, null, 8, _hoisted_10)
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})